export default __webpack_public_path__ + "static/media/laparoscopy.cce0c669.png";